<div class="content-wrapper">
  <div class="container-xxl flex-grow-1 ">
    <mat-toolbar>
      <mat-toolbar-row class="justify-content-between">
        <div class="row mr-2 ml-auto">
          <ul>
            <li>
              <button mat-button class="user mt-2 mb-3 d-flex align-items-center">
                <img [src]="createImgPath(this.logoFile)" class="logo mr-1 p-2" />
              </button>
            </li>
          </ul>
        </div>
        <div class="row mr-2 ml-auto">
          <ul>
            <li>
              <button mat-button class="user mt-1 mb-4 d-flex align-items-right">
                <img src="../../../assets/images/final automated.png" class="user-image mr-1 p-2" />
              </button>
            </li>
          </ul>
        </div>
        <!-- <button mat-button class="user mt-1 mb-4 d-flex align-items-right">
        <img src="../../../assets/images/InfoVision_logo.png" class="user-image mr-1 p-2" />
      </button> -->
      </mat-toolbar-row>
    </mat-toolbar>

    <!-- <form [formGroup]="cardInfoForm" (ngSubmit)="onConfirm()"> -->
    <form [formGroup]="billingSetupForm" (ngSubmit)="onConfirm()">
      <div class="row">
        <div class="col-md-7">
          <mat-card style="padding:30px;">
            <mat-card-header>
              <mat-icon class="nav-icon">feed</mat-icon>
              Bill Payment
            </mat-card-header>
            <hr class="mt-3 mb-4">
            <mat-card-header class="mb-2">
              Billing Information
            </mat-card-header>

            <mat-card-content>
              <mat-grid-list cols="2" rowHeight="450px">
                <mat-grid-tile>
                  <div class="adminControls">
                    <mat-form-field appearance="outline">
                      <mat-label>First Name</mat-label>
                      <input matInput formControlName="billingNameFirst" required
                        [ngClass]="{'is-invalid':submitted && forms.billingNameFirst.errors}" autofocus>
                      <mat-error *ngIf="submitted && forms.billingNameFirst.errors" class="invalid-feedback">
                        <div *ngIf="forms.billingNameFirst.errors.required">FirstName is required</div>
                        <div *ngIf="forms.billingNameFirst.errors.minlength">minimnum length is 2</div>
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>E-mail</mat-label>
                      <input matInput formControlName="billingEmail" required
                        [ngClass]="{'is-invalid':submitted && forms.billingEmail.errors}" autofocus>
                      <mat-error *ngIf="submitted && forms.billingEmail.errors" class="invalid-feedback">
                        <div *ngIf="forms.billingEmail.errors.required">Email is required</div>
                        <div *ngIf="forms.billingEmail.errors.email">Email must be a valid email address</div>
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>Billing Street</mat-label>
                      <input matInput formControlName="billingAddrLine1" required
                        [ngClass]="{'is-invalid':submitted && forms.billingAddrLine1.errors}" autofocus>
                      <mat-error *ngIf="submitted && forms.billingAddrLine1.errors" class="invalid-feedback">
                        <div *ngIf="forms.billingAddrLine1.errors.required">Address is required</div>
                        <div *ngIf="forms.billingAddrLine1.errors.minlength">minimnum length is 2</div>
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>State</mat-label>
                      <!-- <input matInput formControlName="billingState" required
                          [ngClass]="{'is-invalid':submitted && forms.billingState.errors}"> -->
                      <mat-select formControlName="billingState" name="billingState" id="billingState"
                        [ngClass]="{'is-invalid':submitted && forms.billingState.errors}" required>
                        <mat-option *ngFor="let State of states" [value]="State">
                          {{ State }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="submitted && forms.billingState.errors" class="invalid-feedback">
                        <div *ngIf="forms.billingState.errors.required">State is required</div>
                        <!-- <div *ngIf="forms.billingState.errors.minlength">minimnum length is 2</div> -->
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>City</mat-label>
                      <!-- <input matInput formControlName="billingCity" required
                          [ngClass]="{'is-invalid':submitted && forms.billingCity.errors}" autofocus> -->
                      <mat-select formControlName="billingCity" name="billingCity" id="billingCity" required
                        [ngClass]="{'is-invalid':submitted && forms.billingCity.errors}">
                        <mat-option *ngFor="let City of cities" [value]="City">
                          {{ City }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="submitted && forms.billingCity.errors" class="invalid-feedback">
                        <div *ngIf="forms.billingCity.errors.required">City is required</div>
                      </mat-error>
                    </mat-form-field>

                    <!-- <mat-form-field appearance="outline">
                        <mat-label>Country</mat-label>
                        <input matInput formControlName="country" name="country" id="country"> -->
                    <!-- required
                        [ngClass]="{'is-invalid':submitted && forms.country.errors}" autofocus> -->
                    <!-- <select matNativeControl id="country" formControlName="country" name="country"
                        [ngClass]="{'is-invalid':submitted && forms.country.errors}" required>
                        <option value=""></option>
                        <option value="Australia">Australia</option>
                        <option value="Bangladesh">Bangladesh</option>
                        <option value="China">China</option>
                        <option value="France">France</option>
                        <option value="Germany">Germany</option>
                        <option value="India">India</option>
                        <option value="Mexico">Mexico</option>
                        <option value="Philippines">Philippines</option>
                        <option value="Russia">Russian Federation</option>
                        <option value="South Africa">South Africa</option>
                        <option value="Thailand">Thailand</option>
                        <option value="Turkey">Turkey</option>
                        <option value="Ukraine">Ukraine</option>
                        <option value="United Arab Emirates">United Arab Emirates</option>
                        <option value="United Kingdom">United Kingdom</option>
                        <option value="United States">United States</option>
                      </select> -->
                    <!-- <mat-error *ngIf="submitted && forms.country.errors" class="invalid-feedback">
                        <div *ngIf="forms.country.errors.required">Country is required</div>
                      </mat-error> 
                      </mat-form-field>-->
                  </div>
                </mat-grid-tile>

                <mat-grid-tile>
                  <div class="adminControls">
                    <mat-form-field appearance="outline">
                      <mat-label>Last Name</mat-label>
                      <input matInput formControlName="billingNameLast" required
                        [ngClass]="{'is-invalid':submitted && forms.billingNameLast.errors}" autofocus>
                      <mat-error *ngIf="submitted && forms.billingNameLast.errors" class="invalid-feedback">
                        <div *ngIf="forms.billingNameLast.errors.required">Lastname is required</div>
                        <div *ngIf="forms.billingNameLast.errors.minlength">minimnum length is 2</div>
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>Phone Number</mat-label>
                      <input matInput formControlName="billingPhoneNumber" placeholder="XXX-XXX-XXXX"
                        (keypress)="onPress($event)" required
                        [ngClass]="{'is-invalid':submitted && forms.billingPhoneNumber.errors}"
                        autocomplete="doNotAutoComplete" appPhoneMask appNumericOnly>
                      <mat-error *ngIf="submitted && forms.billingPhoneNumber.errors" class="invalid-feedback">
                        <div *ngIf="forms.billingPhoneNumber.errors.required">Phone Number is required</div>
                        <div *ngIf="forms.billingPhoneNumber.errors.pattern">Please, Enter 10 digit Mobile
                          Number</div>
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>Billing Apartment/Suite</mat-label>
                      <input matInput formControlName="BillingSuit">
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>Zip Code</mat-label>
                      <input matInput formControlName="billingZipCode" (change)="onZipCodeChange($event)" required
                        [ngClass]="{'is-invalid':submitted && forms.billingZipCode.errors}" OnlynumberDirective
                        autocomplete="doNotAutoComplete">
                      <mat-error *ngIf="submitted  && forms.billingZipCode.errors" class="invalid-feedback">
                        <div *ngIf="forms.billingZipCode.errors.required">ZipCode is required</div>
                        <div *ngIf="forms.billingZipCode.errors.minlength">Mininmum length is 5</div>
                        <div *ngIf="forms.billingZipCode.errors.maxlength">Maximum length is 5</div>
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" style="visibility: hidden;">
                      <mat-label>Zip Code</mat-label>
                      <input matInput>
                    </mat-form-field>
                  </div>
                </mat-grid-tile>
              </mat-grid-list>
            </mat-card-content>
            <!-- </form> -->
          </mat-card>
        </div>

        <div class="col-md-5">
          <mat-card style=" padding:30px;">
            <mat-card-header>
              <mat-icon class="nav-icon">summarize</mat-icon>Service Summary
            </mat-card-header>
            <hr class="mt-3 mb-3">
            <mat-card-content>
              <div class="row" style="margin-left: 15px;">
                <div class="col-12">
                  <div class="pricinginfo">
                    <p class="mb-2 mt-1"><span class="fw-bold">Requested Service : </span> Requested by
                      {{this.serviceName}}</p>
                    <!-- <p class="mb-0"><span class="fw-bold">Loan Number : </span><span> IV-20200568965</span> -->
                    <p class="mb-2"><span class="fw-bold">Requested For : </span><span>M/S
                        {{this.billingSetupForm.value.payeeNameFirst}} for property at
                        {{this.serviceD}}</span>
                    <p class="mb-2"><span class="fw-bold">Charge Amount : $</span><span>{{this.serviceCharge}}</span>
                  </div>
                </div>
              </div>
            </mat-card-content>
            <hr class="mt-3 mb-4">

            <mat-card-content>
              <mat-card-header class="mb-2">
                <mat-icon class="nav-icon">payment</mat-icon>Card Information
              </mat-card-header>

              <mat-grid-list cols="1" rowHeight="203px">
                <mat-grid-tile>
                  <div class="adminControl">
                    <mat-form-field appearance="outline">
                      <mat-label>Card Owner</mat-label>
                      <input matInput formControlName="ccName" required
                        [ngClass]="{'is-invalid':submitted && forms.ccName.errors}">
                      <mat-error *ngIf="submitted  && forms.ccName.errors" class="invalid-feedback">
                        <div *ngIf="forms.ccName.errors.required">Card owner is required</div>
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>Card Number</mat-label>
                      <div class="vertical-line"></div>
                      <input matInput formControlName="ccNumber" required (input)="onCardNumberChange()"
                        (keypress)="onCreditPress($event)"
                        (ngModelChange)="validateCreditCard()"
                        [ngClass]="{'is-invalid':submitted && forms.ccNumber.errors}" appNumericOnly appNumeric
                        autocomplete="off">
                      <mat-error *ngIf="submitted  && forms.ccNumber.errors" class="invalid-feedback">
                        <div *ngIf="forms.ccNumber.errors.required">credit-card number is required</div>
                        <div *ngIf="forms.ccNumber.errors.minlength">Mininmum length is 15</div>
                        <div *ngIf="forms.ccNumber.errors.maxlength">Maximum length is 16</div>
                      </mat-error>
                      <span matSuffix class="image-icon">
                        <div class="row">
                          <div class="col">
                            <img
                              src="../../../assets/images/american_express-2b72d4ea917edf6321c740a33b2c69a76fefc1a6e002373153e915f77602389d.png">
                          </div>
                          <div class="col">
                            <img
                              src="../../../assets/images/discover-c04aa3a0f782228eb23f99bb527b966550230608a60a0bcda0ebf9f6a56a92e5.png">
                          </div>
                          <div class="col">
                            <img
                              src="../../../assets/images/jcb-8d46ea51be4e4c1623c309748f12cbc06a54313516db5c3fb022350368d9e834.png">
                          </div>
                        </div>
                        <div class="row">
                          <div class="col">
                            <img
                              src="../../../assets/images/mastercard-c273e6f77ab5b2a88ebd12ac5cf16ab0cf7facce52c7d53d1425b7112aac2ace.png">
                          </div>
                          <div class="col">
                            <img
                              src="../../../assets/images/us_bank_account-261d3429c53f337da842085db512ddb13298c7de0b5ac7926ae0bb9ced6b7c95.png">

                          </div>
                          <div class="col"> <img
                              src="../../../assets/images/visa-043fd3b23f0b52db2273b3fce04825a802d140991a64b33790edb95ce85214b2.png">
                          </div>
                        </div>
                      </span>
                    </mat-form-field>
                    <!-- <button (click)="validateCreditCard()">Check Validity</button> -->
                    <p style="color: red;">{{ validationMessage }}</p>
                  </div>
                </mat-grid-tile>
              </mat-grid-list>
              <!-- {{this.billingSetupForm.value.ccNumber}} -->

              <div class="row">
                <div class="col-sm-8">
                  <div class="form-group"> <label class="mb-4"><span class="hidden-xs">
                        Expiration Date
                      </span></label>

                    <div class="input-group ">
                      <mat-form-field appearance="outline" style="width: 100px;">
                        <mat-label>MM</mat-label>
                        <mat-select matNativeControl id="ccExpMonth" formControlName="ccExpMonth" name="ccExpMonth"
                          [ngClass]="{'is-invalid':submitted && forms.ccExpMonth.errors}" required>
                          <mat-option value="01">01</mat-option>
                          <mat-option value="02">02</mat-option>
                          <mat-option value="03">03</mat-option>
                          <mat-option value="04">04</mat-option>
                          <mat-option value="05">05</mat-option>
                          <mat-option value="06">06</mat-option>
                          <mat-option value="07">07</mat-option>
                          <mat-option value="08">08</mat-option>
                          <mat-option value="09">09</mat-option>
                          <mat-option value="10">10</mat-option>
                          <mat-option value="11">11</mat-option>
                          <mat-option value="12">12</mat-option>
                        </mat-select>
                        <mat-error *ngIf="submitted && forms.ccExpMonth.errors" class="invalid-feedback">
                          <div *ngIf="forms.ccExpMonth.errors.required">MM is required</div>
                        </mat-error>
                      </mat-form-field>
                      <mat-form-field appearance="outline" style="width: 100px;">
                        <mat-label>YY</mat-label>
                        <mat-select matNativeControl id="ccExpYear" formControlName="ccExpYear" name="ccExpYear"
                          [ngClass]="{'is-invalid':submitted && forms.ccExpYear.errors}" required>

                          <mat-option value="23">23</mat-option>
                          <mat-option value="24">24</mat-option>
                          <mat-option value="25">25</mat-option>
                          <mat-option value="26">26</mat-option>
                          <mat-option value="27">27</mat-option>
                          <mat-option value="28">28</mat-option>
                          <mat-option value="29">29</mat-option>
                          <mat-option value="30">30</mat-option>
                          <mat-option value="31">31</mat-option>
                          <mat-option value="32">32</mat-option>
                          <mat-option value="19">33</mat-option>
                          <mat-option value="20">34</mat-option>
                          <mat-option value="21">35</mat-option>
                          <mat-option value="22">36</mat-option>
                        </mat-select>
                        <mat-error *ngIf="submitted && forms.ccExpYear.errors" class="invalid-feedback">
                          <div *ngIf="forms.ccExpYear.errors.required">YY is required</div>
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group"> <label class="mb-4"> <span class="hidden-xs">
                        CSC <i class="fa fa-question-circle d-inline"></i></span>
                    </label>
                    <div class="">
                      <!-- <mat-form-field appearance="outline" style="width: 100px;">
                        <mat-label>CSC</mat-label>
                        <input matInput formControlName="csc" (input)="validateInput($event)" required
                          OnlynumberDirective [ngClass]="{'is-invalid':submitted && forms.csc.errors}">
                        <mat-error *ngIf="submitted && forms.csc.errors" class="invalid-feedback">
                          <div *ngIf="forms.csc.errors.required">CSC is required</div>
                          <div *ngIf="forms.csc.errors.minlength">minimnum length is 3</div>
                          <div *ngIf="forms.csc.errors.maxlength">maximum length is 3</div>
                        </mat-error>
                      </mat-form-field> -->

                      <mat-form-field appearance="outline" style="width: 100px;">
                        <mat-label>CSC</mat-label>
                        <input matInput [type]="hide ? 'password' : 'text'" name="csc" formControlName="csc" required
                          id="csc" [ngClass]="{ 'is-invalid': submitted && forms.csc.errors }"
                          (input)="validateInput($event)">

                        <button mat-icon-button matSuffix (click)="hide = !hide " type="button"
                          [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                          <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                        </button>
                        <mat-error *ngIf="submitted && forms.csc.errors" class="invalid-feedback">
                          <div *ngIf="forms.csc.errors.required">CSC is required</div>
                          <div *ngIf="forms.csc.errors.minlength">minimnum length is 3</div>
                          <div *ngIf="forms.csc.errors.maxlength">maximum length is 3</div>
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <mat-checkbox color="primary" class="mb-1" #confirmed> Yes, I agree to pay by accepting all the

              </mat-checkbox>
              <a (click)="openDialog()" class="term">Terms and Condtions</a>
              <div class="termssection">
                <button mat-raised-button color="primary" class="mb-1" type="submit" [disabled]="!confirmed.checked"
                  color="primary" (click)="onSubmit()"> Submit Payment</button>
              </div> -->

            </mat-card-content>
          </mat-card>
        </div>
      </div>
      <mat-card>
        <div class="row">
          <div class="col-md-12" style="padding: 30px;">
            <mat-card-content>
              <strong>IMPORTANT INFORMATION</strong>
              <div class="mt-2">{{paymentEntryVerbiage}}
              </div>
              <mat-checkbox color="primary" class="mb-1 mt-3" #confirmed> YES, I agree to pay the fee(s) in accordance
                with the terms above.
              </mat-checkbox>
              <!-- <a (click)="openDialog()"><span class="term">Terms and Condtions</span></a> -->
              <div class="termssection" style="text-align: right; right: 70px;">
                <button class="button" mat-raised-button type="submit" [disabled]="!confirmed.checked"
                  [disabled]="!isCreditCardValid" (click)="onSubmit()"> Submit Payment</button>
              </div>
            </mat-card-content>
            <alert class="notification"></alert>
          </div>
        </div>
      </mat-card>
    </form>
    <div class="footer">
      <app-footer></app-footer>
    </div>
  </div>
</div>

<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':displayStyle}">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title"><b>Session Timeout!</b></h4>
      </div>
      <div class="modal-body">
        <p><b>Your session has timeout. Please close the window.</b></p>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="closePopup()">
          Close
        </button>
      </div>
    </div>
  </div>
</div>